import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from './../../../theme/constants';
import config from './../../../config';

export const GeoMetaPicker = styled.div`
   position: absolute;
   min-height: 100vh;
   width: 100%;
   top: 0;
   left: 0;
   background: #ffffff;
   margin: 0 auto;
   z-index: 900;
   padding: 0px;
   visibility: hidden;
   opacity: 0;
   -webkit-transition: visibility 0s 0.2s, opacity 0.2s ease-in-out; /* Safari */
   transition: visibility 0s 0.2s, opacity 0.2s ease-in-out;
   box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);

   &.active {
      display: block;
      visibility: visible;
      opacity: 1;
      -webkit-transition: all 0.2s; /* Safari */
      transition: all 0.2s;
   }

   @media (min-width: 1024px) {
      overflow: auto;
      -webkit-box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
      -moz-box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
      box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
   }
`;
export const GeoMetaPickerClose = styled.div`
   box-sizing: border-box;
   width: 100%;
   height: 46px;
   position: relative;
   padding: 20px 10px 50px;

   &:after {
      content: 'CLOSE';
      display: block;
      position: absolute;
      right: 11px;
      width: 33px;
      height: 46px;
      padding-top: 28px;
      ${TYPOGRAPHY.BOLD}
      font-size: 10px;
      color: #c9c9c9;
   }

   svg {
      position: absolute;
      right: 30px;
      padding-top: 10px;
   }

   @media (min-width: 1024px) {
      &:after {
         right: 20px;
         cursor: pointer;
      }
   }
`;
export const GeoMetaPickerWrapper = styled.div``;
export const GeoMetaPickerContainer = styled.div`
   border-bottom: 1px solid #e5e5e5;
   padding: 10px 0;

   &:last-of-type {
      border-bottom: none;
   }

   &.stack {
      margin-left: 0px;
   }

   @media (min-width: 1024px) {
      border-bottom: none;
      padding: 0px 10px;
      display: block;
      float: left;

      &.stack {
         float: none !important;
         margin: 0 0 10px 0;
      }
   }

   @media (min-width: 1340px) {
      padding: 0px 30px 0 10px;

      &.stack {
         margin-left: 85px;
      }
   }
`;

export const GeoMetaPickerCountriesCountry = styled.li`

    a {
        ${TYPOGRAPHY.LIGHT}
        display: block;
        font-size: 15px;
        line-height: 1.2;
        color: ${COLOR.BLACK};
        text-decoration: none;
        cursor: pointer;

        &:hover {
        text-decoration: none;
        }

        &.active {
        ${TYPOGRAPHY.BOLD};
        color: ${COLOR.RED};
    }

    @media (min-width: 1024px) {
        padding: 5px;
    }
`;
export const GeoMetaPickerRegion = styled.div`
   a {
      display: block;
      padding: 13px 10px;
      ${TYPOGRAPHY.BOLD}
      font-size: 16px;
      color: ${COLOR.BLACK};
      text-decoration: none;
      cursor: pointer;

      &:hover {
         text-decoration: none;
      }

      &.active {
         ${TYPOGRAPHY.BOLD}
         color: ${COLOR.RED};
      }
   }
`;
export const GeoMetaPickerCountries = styled.ul`
   list-style: none;
   margin: 0;
   padding: 0 0 0 20px;

   @media (min-width: 1024px) {
      padding: 0 0 0 15px;
   }
`;
